<template>
  <div ref="root" class="timelineEvent">
    <timeline
      ref="timeline"
      :items="items"
      :options="options"
      :events="[
        'rangechange',
        'rangechanged',
        'mouseDown',
        'timechange',
        'timechanged',
        'select',
      ]"
      @dragover="mouseover = true"
      @mousedown.prevent="mouseover = true"
    />
    <div
      class="timelineEvent-trim"
      :style="{
        left: frameRect.left + 'px',
        width: frameRect.width + 'px',
      }"
    ></div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'TimelineEvent',
  props: {
    name: {
      type: String,
      default: '',
    },
    start: {
      type: String,
      default: () => dayjs().subtract(8, 'days').format('YYYY-MM-DDTHH:mm:ss'),
    },
    end: {
      type: String,
      default: () => dayjs().format('YYYY-MM-DDTHH:mm:ss'),
    },
    periodStart: {
      type: String,
      default: () => '0',
    },
    periodEnd: {
      type: String,
      default: () => '0',
    },
    events: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentDuration: 1,
      selectedTimeRange: 1,
      groups: [],
      options: {
        editable: false,
        start: this.start,
        end: this.end, // about three months in milliseconds
        format: {
          minorLabels: {
            day: 'MM/D',
            weekday: 'MM/D',
          },
        },
        zoomable: false,
        moveable: false,
        timeAxis: { scale: 'day', step: 1 },
        type: 'range',
        width: '331px',
      },
      currentEvent: null,
      frameRect: {
        left: 0,
        width: 0,
      },
    };
  },
  computed: {
    items() {
      const items = this.events;

      return items.map((item) => ({
        ...item,
        type: 'background',
        className: 'videoSeek_event',
      }));
    },
    diff() {
      return dayjs(this.end).diff(dayjs(this.start));
    },
  },
  watch: {
    periodStart: {
      handler(val) {
        if (val) {
          this.calculateFrame();
        }
      },
    },
    periodEnd: {
      handler(val) {
        if (val) {
          this.calculateFrame();
        }
      },
    },
  },

  mounted() {
    this.calculateFrame();
  },
  methods: {
    calculateFrame() {
      const { root } = this.$refs;

      if (!root) {
        return;
      }
      const width = root.getBoundingClientRect().width - 7;
      const eachPixelInMs = this.diff / width;
      const border = 3;
      const period = dayjs(this.periodEnd).diff(dayjs(this.periodStart));
      const frameWidth = (period * width) / this.diff;
      const diffStart = dayjs(this.periodStart).diff(dayjs(this.start));
      const frameLeft = diffStart / eachPixelInMs;
      this.$set(this.frameRect, 'width', frameWidth + border * 2);
      this.$set(this.frameRect, 'left', frameLeft - border + 1);
    },
  },
};
</script>

<style lang="scss">
.timelineEvent {
  position: relative;
  &-trim {
    position: absolute;
    top: -4px;
    right: 0px;
    z-index: 1;
    width: 34px;
    height: 28px;
    border: solid 3px #37a34a;
  }
  &_right {
    display: flex;
    align-items: center;
  }
  &_date {
    display: flex;
    justify-content: center;
    font-size: 18px;
    line-height: 32px;
    font-weight: 600;
    position: absolute;
    width: 100%;
    text-align: center;
    top: 0;
    color: var(--primary-color);
    @media (max-width: 1199px) {
      top: 32px;
    }
    &-fullscreen {
      padding-right: 40px;
    }
  }
  &_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
    @media (max-width: 1199px) {
      margin-bottom: 60px;
    }
  }
  &_header-gap {
    margin-bottom: 28px;
    height: 28px;
    @media (max-width: 1199px) {
      margin-bottom: 60px;
    }
  }
  &_btn {
    margin-right: 10px;

    &_icon {
      margin-right: 6px;
      font-size: 13.3px;
    }
    &-active {
      box-shadow: 0 1px 2px 0 rgb(0 0 0 / 16%) !important;
      background-color: #dbe2f3 !important;
    }
  }
  &_menu {
    color: #c9cbd5;
  }
  &_time {
    font-size: 16px;
    line-height: 24px;
    height: 24px;
    font-weight: 600;
    width: 100%;
    text-align: center;
    color: inherit;
  }
  &_time-range {
    width: 120px;
    .v-text-field {
      padding-top: 0;
      margin-top: 0;
      .v-input__append-inner {
        padding-left: 0;
      }
    }
    .v-input__slot {
      margin-bottom: 0;
    }
    .v-text-field__details {
      display: none;
    }
    .v-select__selection {
      flex-grow: 1;
      text-align: right;
      margin-right: 0;
      max-width: 100%;
    }
    .v-text-field input {
      width: 0;
      flex-grow: 0;
    }
    .v-select__selection.v-select__selection--comma {
      font-size: 12px;
      font-weight: 600;
      color: #989898;
    }
    .v-text-field > .v-input__control > .v-input__slot:before {
      content: none;
    }
    .v-text-field > .v-input__control > .v-input__slot:before {
      border-style: none;
    }
    .v-text-field > .v-input__control > .v-input__slot:after {
      border-style: none;
    }
  }
  &_vod {
    display: flex;
    justify-content: center;
    align-items: center;
    &-gap {
      height: 35px;
    }
    &_speed {
      width: 120px;
      .v-text-field {
        padding-top: 0;
        margin-top: 0;
        .v-input__append-inner {
          padding-left: 0;
        }
      }
      .v-input__slot {
        margin-bottom: 0;
      }
      .v-text-field__details {
        display: none;
      }
      .v-select__selection {
        flex-grow: 1;
        text-align: right;
        margin-right: 0;
        max-width: 100%;
      }
      .v-text-field input {
        width: 0;
        flex-grow: 0;
      }
      .v-select__selection.v-select__selection--comma {
        font-size: 12px;
        font-weight: 600;
        color: #989898;
      }
      .v-text-field > .v-input__control > .v-input__slot:before {
        content: none;
      }
    }
    &_btn {
      &.v-btn:not(.v-btn--round).v-size--default {
        padding: 0;
        min-width: 35px;
        margin: 0 5px;
      }
      .icon {
        color: #989898;
        font-size: 26px;
      }
    }
    &_liveToggle {
      height: 21px;
      width: 120px;
      display: flex;
      justify-content: center;
      &-btn {
        &.theme--light.v-btn.v-btn--has-bg {
          background-color: #dbe2f3;
          height: 21px;
          padding: 0 6px;
        }
        .v-btn__content {
          font-size: 14px;
          font-weight: 600;
          line-height: 21px;
        }
      }
    }
  }
  &_indicator {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 6.5px 0 6.5px;
    border-color: #999 transparent transparent transparent;
    &_container {
      display: flex;
      justify-content: center;
      margin-top: 5px;
    }
  }
  &_bar {
    border-radius: 5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    min-height: 41px;
    position: relative;
  }

  &_event {
    background-color: var(--primary-color) !important;
    cursor: pointer;
  }

  .vis-timeline {
    border: 0;
    height: 41px !important;
  }
  .vis-panel {
    height: 19px !important;
    &.vis-background.vis-vertical {
      overflow: visible;
    }
  }
  .vis-current-time {
    background-color: #f3f3f3 !important;
    width: 100% !important;
    height: 18px !important;
  }
  .vis-time-axis.vis-background {
    height: 14px !important;
    top: 9px !important;
    z-index: 3 !important;
    pointer-events: none;
  }

  .vis-time-axis .vis-grid.vis-minor,
  .vis-time-axis .vis-grid.vis-major {
    height: 12px !important;
    border-left: 1px solid #999;
    top: -18px;
    background-image: none;
    background-size: 100% 8px;
    background-position: bottom;
  }
  .vis-text.vis-minor {
    left: -18px;
    font-size: 11px;
    font-weight: normal;
    color: #999;
  }
  .vis-time-axis.vis-foreground {
    height: 22px;
  }
  .vis-text.vis-major {
    display: none;
  }
  .vis-panel {
    &.vis-center {
      height: 19px !important;
      border-top: 0;
      top: 0px !important;
      pointer-events: all;
      z-index: 1;
      border: transparent;
    }
    &.vis-top {
      background-color: #c9effc;
      border: transparent;
      border-radius: 5px;
    }
  }
  .vis-shadow {
    display: none;
  }
  .vis-item.vis-range {
    top: 0 !important;
    border-width: 0;
    border-radius: 0;
    height: 18px;
    min-width: 15px;
  }
  .vis-panel > .vis-content {
    transform: translateY(0) !important;
  }
  .vis-itemset {
    height: 18px !important;
  }
  .vis-group {
    height: 19px !important;
  }
  .vis-panel.vis-bottom {
    top: 19px !important;
    border: transparent !important;
  }
  .vis-panel.vis-left {
    border: transparent !important;
  }
  &_fullscreen {
    .videoSeek {
      &_date {
        padding-right: 40px;
        color: #fff;
      }
      &_vod {
        color: #fff;
        &_btn {
          color: inherit !important;
          .v-btn__content {
            color: inherit;
            .icon {
              color: inherit;
            }
          }
        }
        &_speed {
          color: inherit;
          .v-select {
            color: inherit;
            .v-input__slot {
              color: inherit;
              .v-select__selections {
                color: inherit;
                .v-select__selection--comma {
                  color: inherit;
                }
              }
              .v-input__append-inner {
                .theme--light.v-icon {
                  color: inherit;
                }
              }
            }
          }
        }
        &_liveToggle {
          &-btn {
            background-color: transparent !important;
            border: solid 1px #fff;
            color: #fff !important;
          }
        }
      }
      &_bar {
        box-shadow: none;
      }
      &_indicator {
        border-color: #fff transparent transparent transparent;
      }
    }
    // timeline
    .vis-panel {
      &.vis-center {
        border-right: 1px solid #bfbfbf !important;
        border-left: 1px solid #bfbfbf !important;
      }
      &.vis-top {
        background-color: #8a9da4;
      }
    }
    .vis-text.vis-minor {
      color: #fff;
    }
    .vis-panel.vis-bottom,
    .vis-panel.vis-center,
    .vis-panel.vis-left,
    .vis-panel.vis-right,
    .vis-panel.vis-top {
      border: transparent !important;
    }
    .vis-time-axis .vis-grid.vis-minor,
    .vis-time-axis .vis-grid.vis-major {
      border-left: 1px solid #fff;
      border-right: 1px solid #fff;
      background-image: linear-gradient(
        90deg,
        transparent 0%,
        transparent calc(20% - 1px),
        #fff calc(20% - 1px),
        #fff 20%,
        transparent 20%,
        transparent calc(40% - 1px),
        #fff calc(40% - 1px),
        #fff 40%,
        transparent 40%,
        transparent calc(60% - 1px),
        #fff calc(60% - 1px),
        #fff 60%,
        transparent 60%,
        transparent calc(80% - 1px),
        #fff calc(80% - 1px),
        #fff 80%,
        transparent 80%
      );
    }
    .vis-current-time {
      background-color: #4a4a4a !important;
      width: 100% !important;
      height: 18px !important;
    }
    .vis-itemset .vis-background,
    .vis-itemset .vis-foreground {
      border: 1px solid #bfbfbf !important;
      border-radius: 5px;
    }
  }
}
</style>
